<script lang="ts">
  import { APIHOSTNOW } from "@/config";
  import debounce from "just-debounce-it";

  export let data = "";

  const apihost = APIHOSTNOW;

  let ckeditor = null;

  const timer = setInterval(() => {
    if (window["ckeditor"]) {
      clearInterval(timer);
      ckeditor = window["ckeditor"];
      ckeditor
        .create(document.querySelector("#editor"), {
          initialData: data ?? "",
          simpleUpload: {
            uploadUrl: APIHOSTNOW + "/file/board",
          },
          mediaEmbed: {
            previewsInData: true,
          },
        })
        .then((e) => {
          const inputEvent = (evt) => {
            data = e.getData();
          };

          e.model.document.on("change:data", debounce(inputEvent, 300));
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, 100);
</script>

<svelte:head>
  <script src="/ckeditor/ckeditor.js"></script>
  <script>
    const timer = setInterval(() => {
      if (ClassicEditor) {
        clearInterval(timer);
        window.ckeditor = ClassicEditor;
      }
    }, 300);
  </script>
</svelte:head>

<div id="editor" />
